import React, { useState } from "react";
import RenderButton from "../common/button";

const Headder = ({ onChange, groupid }) => {
  // console.log(groupid)

  const [all, setall] = useState("btn btn-primary");
  const [log, setlog] = useState("btn btn-outline-dark");
  const [chip, setchip] = useState("btn btn-outline-dark");
  const [power, setpower] = useState("btn btn-outline-dark");
  const [paper, setpaper] = useState("btn btn-outline-dark");
  const [pulp, setpulp] = useState("btn btn-outline-dark");
  const [chem, setchem] = useState("btn btn-outline-dark");
  const [other, setother] = useState("btn btn-outline-dark");
  const [WTN, setWTN] = useState("btn btn-outline-dark");
  const [NOB, setNOB] = useState("btn btn-outline-dark");
  const [id1, setid1] = useState("btn btn-outline-dark");
  const [startDate, setStartDate] = useState(new Date());

  const handleonClick = ({ currentTarget: input }) => {
    if (input.value == 2) {
      disabledlabel();
      setlog("btn btn-primary");
    } else if (input.value == 0) {
      disabledlabel();
      setall("btn btn-primary");
    } else if (input.value == 10) {
      disabledlabel();
      setchip("btn btn-primary");
    } else if (input.value == 5) {
      disabledlabel();
      setpower("btn btn-primary");
    } else if (input.value == 13) {
      disabledlabel();
      setpaper("btn btn-primary");
    } else if (input.value == 14) {
      disabledlabel();
      setpulp("btn btn-primary");
    } else if (input.value == 533) {
      disabledlabel();
      setNOB("btn btn-primary");
    } else if (input.value == 3) {
      disabledlabel();
      setother("btn btn-primary");
    } else if (input.value == 529) {
      disabledlabel();
      setWTN("btn btn-primary");
    } else if (input.value == 11) {
      disabledlabel();
      setchem("btn btn-primary");
    }
    else if (input.value == 1) {
      disabledlabel();
      setid1("btn btn-primary");
    }
    onChange(input.value);
  };
  // const handleChange = (date) => {
  //     setStartDate(date)
  //     handleDateChange(date);
  // }

  const disabledlabel = () => {
    setall("btn btn-outline-dark");
    setlog("btn btn-outline-dark");
    setchip("btn btn-outline-dark");
    setWTN("btn btn-outline-dark");
    setpaper("btn btn-outline-dark");
    setchem("btn btn-outline-dark");
    setpulp("btn btn-outline-dark");
    setpower("btn btn-outline-dark");
    setother("btn btn-outline-dark");
     setid1('btn btn-outline-dark') ;
  };

  return (
   
      <div className="row">
        <div className="col-auto mb-1 px-0 ">
          {groupid && groupid == 1 && (
            <>
            <RenderButton
              value="0"
              label="ทั้งหมด"
              onClick={handleonClick}
              className={all}
            />

            <RenderButton
              value="2"
              label="ไม้ท่อน"
              onClick={handleonClick}
              className={log}
            />

            <RenderButton
              value="10"
              label="ไม้สับ"
              onClick={handleonClick}
              className={chip}
            />
            
            </>
          )}
       
       

          {groupid && groupid == 2 && (
            <>
            <RenderButton
              value="13"
              label="กระดาษ"
              onClick={handleonClick}
              className={paper}
            />

             <RenderButton
              value="14"
              label="เยื่อ"
              onClick={handleonClick}
              className={pulp}
            />
             <RenderButton
              value="11"
              label="สารเคมี"
              onClick={handleonClick}
              className={chem}
            />
            <RenderButton
              value="3"
              label="อื่นๆ"
              onClick={handleonClick}
              className={other}
            />
            </>
          )}
         {groupid && groupid == 3 && (
            <>
             <RenderButton
              value="0"
              label="ทั้งหมด"
              onClick={handleonClick}
              className={all}
            />

                   <RenderButton
              value="1"
              label="2-3 ชม."
              onClick={handleonClick}
              className={id1}
            />

             <RenderButton
              value="2"
              label="3-4 ชม."
              onClick={handleonClick}
              className={log}
            />
             <RenderButton
              value="3"
              label="> 4 ชม."
              onClick={handleonClick}
              className={other}
            />


        
        
            </>
          )}
          {groupid && groupid == 4 && (
            <>
             <RenderButton
              value="0"
              label="ทั้งหมด"
              onClick={handleonClick}
              className={all}
            />

                   <RenderButton
              value="1"
              label="รอลงสินค้า"
              onClick={handleonClick}
              className={id1}
            />

             <RenderButton
              value="2"
              label="CheckOut"
              onClick={handleonClick}
              className={log}
            />
            
            </>)
            }
                 {groupid && groupid == 5 && (
            <>
            <RenderButton
              value="0"
              label="ทั้งหมด"
              onClick={handleonClick}
              className={all}
            />

            <RenderButton
              value="1"
              label="รออนุมัติ"
              onClick={handleonClick}
              className={id1}
            />

            <RenderButton
              value="2"
              label="อนุมัติ"
              onClick={handleonClick}
              className={log}
            />
            
            </>
          )}
       

        </div>
      </div>
  
  );
};

export default Headder;
